import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { PlaceholderCloudImage } from '@components/CloudImage';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 380px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 750px;
    }
  }
`;

export const StyledLeftImageWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(-30px, 135px);
  z-index: 2;
  justify-content: flex-start;
  ${themeMediaQuery('below_sm')} {
    transform: translate(0px, 50px);
    justify-content: center;
  }
  ${themeMediaQuery('xl')} {
    transform: translate(-30px, 178px);
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const StyledDesktopPrintsImage = styled(PlaceholderCloudImage)`
  height: 900px;
  width: 100%;
  ${themeMediaQuery('xl')} {
    height: 1200px;
  }
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMobilePrintsImage = styled(PlaceholderCloudImage)`
  height: 350px;
  width: 100%;
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const StyledRightImageWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(30px, 0px);
  z-index: 2;
  justify-content: flex-end;
  ${themeMediaQuery('below_sm')} {
    transform: translate(0px, 0px);
    justify-content: center;
  }
`;

export const ColumnWrapper = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column-reverse;
    padding-left: 0rem;
    padding-right: 0rem;
  }
`;

export const StyleMiddleColumn = styled(Flex)`
  width: 100%;
  height: 100%;
  justify-content: center;
`;
